import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import { useSelector } from "react-redux";
import { useGetDesc } from "../utils/utils";
import { useTranslation } from "react-i18next";
import QuickActionsDetails from "./QuickActionsDetails";
import ConfiguratorIcons from "../ConfiguratorIcons";

const PREFIX = "eventsDetails";

const classes = {
  root: `${PREFIX}-root`,
  lineDisplay: `${PREFIX}-lineDisplay`,
  flexContent: `${PREFIX}-flexContent`,
  layer: `${PREFIX}-layer`,
  previsualisation: `${PREFIX}-previsualisation`,
  type: `${PREFIX}-type`,
  iconsContainer: `${PREFIX}-iconsContainer`,
  visualizeColor: `${PREFIX}-visualizeColor`,
};

const EventsDetailsContainer = styled("div")(({ theme }) => {
  return {
    [`& .${classes.root}`]: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "100%",
    },
    [`& .${classes.lineDisplay}`]: {
      width: "100%",
      height: "18%",
      padding: "0.5rem",
      margin: "3px 0",
      backgroundColor: "#424242",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "space-between",
    },
    [`& .${classes.flexContent}`]: {
      display: "flex",
      alignItems: "center",
    },
    [`& .${classes.layer}`]: {
      width: "50px",
    },
    [`& .${classes.previsualisation}`]: {
      [theme.breakpoints.between("xs", "sm")]: {
        width: 0,
      },
      width: "120px",
      height: "24px",
      marginRight: "1rem",
      display: "flex",
      justifyContent: "center",
    },
    [`& .${classes.type}`]: {
      [theme.breakpoints.between("xs", "sm")]: {
        width: "inherit",
      },
      width: "120px",
      marginRight: "1rem",
    },
    [`& .${classes.iconsContainer}`]: {
      [theme.breakpoints.between("xs", "sm")]: {
        textWrap: "nowrap",
        overflow: "hidden",
      },
    },
    [`& .${classes.visualizeColor}`]: {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
    },
  };
});

const Description = (myTile, key) => {
  const myDesc = useGetDesc(myTile ? myTile[key] : null);
  return myDesc;
};

const EventsDetails = () => {
  const { t } = useTranslation();
  const selectedTile = useSelector((state) => state.configurator.selectedTile);
  const parentLayout = useSelector((state) => state.configurator.parentLayout);
  const myTile = useSelector((state) =>
    selectedTile
      ? state.configurator.grid[parentLayout][selectedTile.row][
          selectedTile.column
        ]
      : null
  );
  return (
    <EventsDetailsContainer sx={{ width: "100%" }}>
      <div className={classes.root}>
        <Paper elevation={5}>
          <div className={classes.lineDisplay}>
            <div className={classes.flexContent}>
              <div className={classes.layer}>{t(`configurator.event`)}</div>
              <div className={classes.previsualisation}>
                <ConfiguratorIcons
                  orientation={{ type: myTile.event.type }}
                  isForDialog
                  side="neutralPosition"
                />
                {myTile?.event.color && (
                  <div
                    className={classes.visualizeColor}
                    style={{
                      backgroundColor: `rgba(${myTile.event.color.r}, ${myTile.event.color.g}, ${myTile.event.color.b}, ${myTile.event.color.a}`,
                    }}
                  />
                )}
              </div>
              <div className={classes.type}>{Description(myTile, "event")}</div>
            </div>
            <div className={classes.iconsContainer}>
              <QuickActionsDetails />
            </div>
          </div>
        </Paper>
      </div>
    </EventsDetailsContainer>
  );
};

export default EventsDetails;
